import Component from '../abstracts/Component';
import {Zero, Components} from 'Zero';
import {ZDetail} from "StoreLocatorSubcomponents/sl_detail.js";

export default class StoreLocatorDetailComponent extends Component {

  render() {
    super.render();
    let _this = this;

    window.InitGoogle = function () {};
    const googleApiKey = $("#googleApiKey").val();
    const googleLanguage = $("#googleLanguage").val();

    const apiUrl = `https://maps.googleapis.com/maps/api/js?v=3.35&key=${googleApiKey}&libraries=places,geometry&callback=InitGoogle&language=${googleLanguage}`;

    this.moduleLoader.loadExternalScript(apiUrl).then(() => {
      window.Zero = Zero;

      Components.create('ZDetail', ZDetail);

      Zero.start( {} );

    });
  }
}
